
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.625 5.625C1.625 3.41586 3.41586 1.625 5.625 1.625H13.875C16.0841 1.625 17.875 3.41586 17.875 5.625V6.125H18.375C20.5841 6.125 22.375 7.91586 22.375 10.125V18.375C22.375 20.5841 20.5841 22.375 18.375 22.375H10.125C7.91586 22.375 6.125 20.5841 6.125 18.375V17.875H5.625C3.41586 17.875 1.625 16.0841 1.625 13.875V5.625ZM6.125 15.875V10.125C6.125 7.91586 7.91586 6.125 10.125 6.125H15.875V5.625C15.875 4.52043 14.9796 3.625 13.875 3.625H5.625C4.52043 3.625 3.625 4.52043 3.625 5.625V13.875C3.625 14.9796 4.52043 15.875 5.625 15.875H6.125ZM10.125 8.125C9.02043 8.125 8.125 9.02043 8.125 10.125V18.375C8.125 19.4796 9.02043 20.375 10.125 20.375H18.375C19.4796 20.375 20.375 19.4796 20.375 18.375V10.125C20.375 9.02043 19.4796 8.125 18.375 8.125H10.125Z","fill":"#16171F"}})])
          )
        }
      }
    